import { Directive, forwardRef, Attribute } from '@angular/core';
import { NG_VALIDATORS, Validator, Validators, AbstractControl, ValidatorFn } from '@angular/forms';


@Directive({
  selector: '[appCompare]',
  providers: [
    { provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CompareDirective),
      multi: true }
  ]
})
export class CompareDirective implements Validator {

  constructor(@Attribute('appCompare') public comparer: string,
              @Attribute('parent') public parent: string) {}

  validate(c: AbstractControl): {[key: string]: any} {
    const e = c.parent.get(this.comparer);

    // value not equal in verify control
    if (e && c.value !== e.value && !this.isParent) {
      return {'compare': true};
    }

    // user typing in password and match
    if (e && c.value === e.value && this.isParent) {
        delete e.errors['compare'];
        if (!Object.keys(e.errors).length) { e.setErrors(null); }
    }

    // user typing in password and mismatch
    if (e && c.value !== e.value && this.isParent) {
        e.setErrors({ 'compare': true });
    }
  }

  private get isParent() {
    if (!this.parent) {
      return false;
    }

    return this.parent === 'true' ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/Directives/compare.directive.ts